import { Injectable, Inject, forwardRef } from '@nestjs/common';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { getManager } from 'typeorm';
import { BranchesResponseModel } from '@gtpl/shared-models/gtpl';
@Injectable()
export class BranchesService {

  constructor(
   
  ) {}
  // @LogActions({isAsync: true})
  async getBranches():Promise<BranchesResponseModel> {
    const manager = getManager();
    const query='select id as branchId,bName as branchName from branches order by bName';
    const branchDetails = await manager.query(query);
    const response = new BranchesResponseModel(true, 11100, 'Branches retrived successfully', branchDetails);
    return response;
  }
}